{
  "placeholders": {
    "companyName": "Enter your company name",
    "companyWebsite": "https://example.com",
    "adminEmail": "admin@example.com"
  },
  "validation": {
    "companyNameRequired": "Company name is required",
    "companyWebsiteRequired": "Company website is required",
    "validUrlRequired": "Please enter a valid URL",
    "companySizeRequired": "Company size is required",
    "countryRequired": "Country is required",
    "validPhoneRequired": "Please enter a valid phone number with country code"
  },
  "time": {
    "minutesAgo_other": "{{count}} min ago",
    "hoursAgo_other": "{{count}}h ago",
    "daysAgo_other": "{{count}}d ago"
  },
  "components": {
    "mainMenu": {
      "organizations": "Organisations (Internal)",
      "organization": "$t(clientAccess:breadcrumbs.organization.index)",
      "dashboard": "$t(clientAccess:breadcrumbs.organization.dashboard)",
      "applications": "$t(clientAccess:breadcrumbs.applications.index)",
      "oauthClients": "$t(clientAccess:breadcrumbs.oauthClients.index)",
      "usersManagement": "Users Management",
      "groupManagement": "$t(clientAccess:breadcrumbs.groups.dashboard)"
    },
    "stepIndicator": {
      "stepOfTotal": "Step {{current}} of {{total}}",
      "current": "current",
      "completed": "completed"
    }
  },
  "breadcrumbs": {
    "organization": {
      "index": "Organisation",
      "dashboard": "Dashboard"
    },
    "oauthClients": {
      "index": "OAuth Clients",
      "detail": "$t(common:labels.clientDetails)",
      "create": "Create Client"
    },
    "applications": {
      "index": "$t(common:components.mainMenu.applications)",
      "technicalConfiguration": "Technical Configuration"
    },
    "users": {
      "index": "$t(common:labels.users)",
      "dashboard": "$t(common:components.mainMenu.ssoConfiguration)",
      "directory": "User Directory",
      "create": "Create User",
      "invite": "Invite User",
      "profile": "User Details",
      "edit": "Edit User"
    },
    "groups": {
      "index": "Groups",
      "dashboard": "Group Management",
      "create": "Create Group",
      "details": "Group Details",
      "edit": "Edit Group"
    },
    "sso": {
      "index": "$t(common:components.mainMenu.ssoConfiguration)",
      "configure": "Configure SSO"
    }
  },
  "errors": {
    "genericError": "An error occurred. Please try again."
  },
  "externalLogin": {
    "errors": {
      "invalidRedirectUri": "Missing or invalid redirect_uri. Must be an https:// URI.",
      "missingClientId": "Missing client_id. Pass as a query parameter or set VITE_COGNITO_CLIENT_ID.",
      "missingDomain": "Cognito not configured: VITE_COGNITO_DOMAIN is required.",
      "ssoExpired": "This sign-in has expired or was started in another tab. Go back to the application and sign in again.",
      "ssoFailed": "Single sign-on could not be completed. Go back to the application and sign in again."
    }
  }
}
